import React from 'react';
import { motion } from 'framer-motion';
import { TECH_FEATURES } from '../../data/techFeatures';
import { NfcUnlockIcon } from './TechIcons';

export function UnlockAndGo() {
  const data = TECH_FEATURES.find(f => f.id === 'nfc');
  if (!data) return null;

  return (
    <section id="nfc" className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Visual Side */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative flex items-center justify-center py-12 order-2 lg:order-1"
          >
            {/* Background */}
            <div className="absolute w-72 h-72 bg-zinc-100 rounded-full" />
            <div className="absolute w-80 h-80 rounded-full border-2 border-dashed border-zinc-200" />

            {/* Icon */}
            <motion.div
              className="relative z-10"
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              <NfcUnlockIcon className="w-48 h-48 text-zinc-800" />
            </motion.div>

            {/* Ripple Effect */}
            {[1, 2, 3].map((i) => (
              <motion.div
                key={i}
                className="absolute w-32 h-32 rounded-full border-2 border-zinc-300"
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{
                  scale: [0.5, 1.5],
                  opacity: [0.6, 0]
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 0.6,
                  ease: "easeOut"
                }}
                style={{ left: '30%', top: '35%' }}
              />
            ))}
          </motion.div>

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8 order-1 lg:order-2"
          >
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-zinc-100 text-zinc-700 text-sm font-medium mb-4">
                Desbloqueo Seguro
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-zinc-900 mb-6 leading-tight">
                {data.title}
              </h2>
              <p className="text-xl text-zinc-600 leading-relaxed mb-6">
                {data.description}
              </p>
            </div>

            {/* Benefits */}
            <div className="grid grid-cols-1 gap-6 pt-6 border-t border-zinc-200">
              {data.benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-zinc-900 rounded-lg flex items-center justify-center flex-shrink-0 text-white font-bold">
                    {idx + 1}
                  </div>
                  <div>
                    <div className="text-lg font-bold text-zinc-900 mb-1">{benefit.title}</div>
                    <div className="text-zinc-500 text-sm">{benefit.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
